/** Einstellungen: lesbare Namen, Feldtypen und Gruppen */
export type SubField = { key: string; label: string; type: 'number' | 'text' };
export type Def = { label: string; group: string; hint?: string; unit?: string } & (
  | { type: 'number' }
  | { type: 'text'; inputType?: 'email' | 'url'; placeholder?: string }
  | { type: 'bool' }
  | { type: 'numberList' }
  | { type: 'monthRange' }
  | { type: 'object'; fields: SubField[] }
);

export const GROUPS = ['Verein', 'Aktionen', 'Monitoring', 'Anmeldung und Ablage'];

/** Bekannte Einstellungen: lesbarer Name, Feldtyp, Einheit. Unbekannte Schlüssel landen unter „Erweitert“. */
export const DEFS: Record<string, Def> = {
  org_name: { group: 'Verein', label: 'Vereinsname', type: 'text', hint: 'in Dokumenten und E-Mails' },
  org_address: { group: 'Verein', label: 'Anschrift', type: 'text', hint: 'im Waldbesitzervertrag und als Rücksendeadresse' },
  org_board: { group: 'Verein', label: 'Vertretungsberechtigter Vorstand', type: 'text', hint: 'im Waldbesitzervertrag' },
  org_invoice_email: { group: 'Verein', label: 'E-Mail für Rechnungen', type: 'text', inputType: 'email', hint: 'im Waldbesitzervertrag' },
  action_code_pattern: { group: 'Aktionen', label: 'Muster der Aktionskennung', type: 'text', hint: 'Bausteine {prefix}, {yymmdd}, {partner}, {ort}, z. B. PFM261103_Beiersdorf_Töpsheide' },
  auto_complete_days: { group: 'Aktionen', label: 'Automatisch abschließen', unit: 'Tage nach dem Aktionstag', type: 'number', hint: '-1 = nie' },
  planting_guides_rule: {
    group: 'Aktionen',
    label: 'Gruppenleitungen bei Pflanzaktionen',
    type: 'object',
    fields: [
      { key: 'participants_per_guide', label: 'Teilnehmende je Gruppenleitung', type: 'number' },
      { key: 'tww_guides', label: 'davon von Trinkwasserwald', type: 'number' },
    ],
  },
  season_windows: {
    group: 'Aktionen',
    label: 'Pflanzzeiten (Hinweis im Aktionsassistenten)',
    type: 'object',
    fields: [
      { key: 'herbst', label: 'Herbst', type: 'text' },
      { key: 'fruehjahr', label: 'Frühjahr', type: 'text' },
    ],
  },
  monitoring_intervals_years: { group: 'Monitoring', label: 'Monitoring nach', unit: 'Jahren', type: 'numberList', hint: 'mehrere durch Komma, z. B. 2, 5' },
  monitoring_window: { group: 'Monitoring', label: 'Monitoring-Zeitraum', type: 'monthRange' },
  monitoring_secure_after_years: { group: 'Monitoring', label: '„Kultur gesichert“ vorschlagen nach', unit: 'Jahren', type: 'number' },
  monitoring_inquiry_yearly: { group: 'Monitoring', label: 'In den Zwischenjahren beim Förster nachfragen', type: 'bool' },
  entra_logout: { group: 'Anmeldung und Ablage', label: 'Beim Abmelden auch bei Microsoft abmelden', type: 'bool', hint: 'sinnvoll bei gemeinsam genutzten Geräten' },
  default_due_offsets_locked: { group: 'Erweitert', label: 'Standardfristen festschreiben', type: 'bool', hint: 'Aus: Standardfristen sind Vorschläge und je Aktion änderbar' },
  sharepoint_root_url: { group: 'Anmeldung und Ablage', label: 'Ablage in Microsoft 365', type: 'text', inputType: 'url', hint: 'Adresse des Ordners, unter dem Jahr › Saison › Aktion liegen', placeholder: 'https://…' },
};

/** Lesbarer Name einer Einstellung (auch für das Protokoll) */
export const settingLabel = (key: string) => DEFS[key]?.label ?? key.replace(/_/g, ' ').replace(/^./, (c) => c.toUpperCase());
